"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteHeroService } from "@/lib/actions/admin-dashboard/hero-services/delete/deleteHeroService";

const serverDeleteHeroService = async (id: string) => {
  const response = await deleteHeroService(id);
  return response;
};

export const useDeleteHeroService = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: serverDeleteHeroService,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["hero-services"] });
    },
  });
};
